/* ==========================================================================
   Elevate Floors — mecânica compartilhada de acordeão

   Usada pela Seção 09 da home e pelos dois acordeões da página de serviço
   ("what matters" e a lista de cômodos da faixa navy). O comportamento é o
   mesmo nos três: todos fechados ao carregar, um por vez, clicar no aberto
   fecha.

   O max-height do CSS é piso de segurança (funciona sem JS). Aqui a altura
   exata é medida e escrita, então nenhum texto fica cortado por mais longo
   que seja.
   ========================================================================== */
(function () {
  'use strict';

  function attach(root, opts) {
    opts = opts || {};
    var itemSel = opts.item || '[data-item]';
    var headSel = opts.head;
    var bodySel = opts.body;
    var openClass = opts.openClass || 'is-open';

    var items = Array.prototype.slice.call(root.querySelectorAll(itemSel));
    if (!items.length) return null;

    function closeAll() {
      items.forEach(function (it) {
        it.classList.remove(openClass);
        var h = it.querySelector(headSel);
        var b = it.querySelector(bodySel);
        if (h) h.setAttribute('aria-expanded', 'false');
        if (b) b.style.maxHeight = '';
      });
    }

    items.forEach(function (item) {
      var head = item.querySelector(headSel);
      var body = item.querySelector(bodySel);
      if (!head) return;

      head.addEventListener('click', function () {
        var willOpen = !item.classList.contains(openClass);
        closeAll();                       // um por vez
        if (!willOpen) return;            // clicar no aberto fecha
        item.classList.add(openClass);
        head.setAttribute('aria-expanded', 'true');
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      });
    });

    // a quebra de linha muda a altura. Limpar antes de remedir: senão o
    // scrollHeight devolve o valor antigo em vez do recalculado.
    function remeasure() {
      var open = root.querySelector(itemSel + '.' + openClass + ' ' + bodySel);
      if (!open) return;
      open.style.maxHeight = '';
      open.style.maxHeight = open.scrollHeight + 'px';
    }

    // UM listener global, não um por instância. O editor de tema troca o nó
    // da section a cada save, e o nó novo não carrega a flag de guarda — sem
    // isto, cada save penduraria mais um resize no window, para sempre.
    if (!window._efAccResize) {
      window._efAccResize = [];
      window.addEventListener('resize', function () {
        window._efAccResize.forEach(function (fn) {
          try { fn(); } catch (e) {}
        });
      });
    }
    // só instâncias ainda no documento continuam medindo
    window._efAccResize = window._efAccResize.filter(function (fn) {
      return fn._root && fn._root.isConnected;
    });
    remeasure._root = root;
    window._efAccResize.push(remeasure);

    return { closeAll: closeAll, remeasure: remeasure };
  }

  window.EFAccordion = { attach: attach };
})();
